module.exports = __webpack_public_path__ + "img/caas2.98fd1fef.webp";